// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-K9ve","title":"styles_title__3M6Lr"};